import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Override = (props) => (
  <Icon viewBox="0 0 15 14" {...props}>
    <g>
      <title>override icon</title>
      <g fill="none" fillRule="evenodd">
        <path d="M14 8v1.5a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5V8zm-.5-8h-12C.673 0 0 .673 0 1.5v8c0 .827.673 1.5 1.5 1.5H7v2H5v1h5v-1H8v-2h5.5c.827 0 1.5-.673 1.5-1.5v-8c0-.827-.673-1.5-1.5-1.5z"
          fill="currentColor" />
        <path stroke="currentColor" d="M5 5.5L7 8l4-5" />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default Override;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Override.js